import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as PagesActions from "../../actions/pagesActions";
import * as constants from "../../constants";

const createPageLogic = createLogic({
	type: ActionTypes.CREATE_PAGE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		const { expId, page } = action;
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.post("/pages", {
					...page,
					experienceId: expId,
				})
					.then(() => {
						dispatch(PagesActions.createPageSuccess(expId));
						done();
					})
					.catch(error => {
						dispatch(PagesActions.createPageFail(error));
						done();
					});
			});
	},
});

export default [createPageLogic];
